<template lang="pug">
  v-container.pt-6.px-10(fluid)
    v-breadcrumbs.pt-0.px-0.pb-3(:items="breadcrumbItems")
      template(v-slot:item="{ item }")
        a.text-sm.font-medium.no-underline.neutral700--text(v-if="!item.disabled" @click="item.href") {{ item.text }}
        .text-sm.neutral700--text(v-else) {{ item.text }}

    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
    template(v-else)
      div.d-flex.align-center
        v-btn.ml-n3(text icon @click="goBack" height)
          v-icon(color="neutral700" :size="24") mdi-arrow-left
        .text-2xl.font-semibold.neutral700--text.ml-3(v-if="packageData") {{ packageData.product.name }}

      v-divider.mt-4

      .data-table
        v-data-table.mt-sm-4.pb-6(:headers="headers" :items="records" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetchingRecords" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
          //- date time
          template(v-slot:item.datetime="{ item }")
            .text-sm.neutral700--text {{ item.datetime | convertServerDate2 }}
          //- quantity
          template(v-slot:item.quantity="{ item }")
            .text-sm.neutral700--text {{ item.quantity }}
          //- price tier
          template(v-slot:item.price_tier="{ item }")
            .text-sm.neutral700--text {{ item.extra_data && item.extra_data.price_tier_name }}
          //- price
          template(v-slot:item.price="{ item }")
            .text-sm.neutral700--text.no-wrap {{ item.price | displayPrice($currency) }}
          //- invoice no
          template(v-slot:item.rid="{ item }")
            .text-sm.neutral700--text INV {{ `#${item.rid}` }}
          //- patient
          template(v-slot:item.customer="{ item }")
            div.my-1(v-if="item.customer")
              .text-sm.neutral700--text {{ item.customer.name }}
              .text-xs.neutral500--text {{ item.customer.ic }}

      div.d-flex.align-center(v-if="totalCount > pageSize")
        v-spacer
        yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PackageHistory',
  props: ['id'],
  data () {
    return {
      isFetching: false,
      isFetchingRecords: false,
      pageSize: 20,
      totalCount: 0,
      currentPage: 1,
      packageData: null,
      records: [],
      headers: [
        { text: 'Date and time', value: 'datetime', enable: true, class: 'text-table-header' },
        { text: 'Qty', value: 'quantity', enable: true, class: 'text-table-header', sortable: false },
        { text: 'Price tier', value: 'price_tier', enable: true, class: 'text-table-header' },
        { text: 'Price', value: 'price', enable: true, class: 'text-table-header' },
        { text: 'Invoice no', value: 'rid', enable: true, class: 'text-table-header' },
        { text: 'Patient', value: 'customer', enable: true, class: 'text-table-header' },
      ],
      breadcrumbItems: [
        { text: 'Packages', disabled: false, href: () => (this.goToPackages()) },
        { text: 'Package history', disabled: true }
      ]
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
  },
  watch: {
    pageSize () {
      this.currentPage = 1
      this.fetchPackageHistory()
    }
  },
  mounted () {
    this.fetchPackage()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPackage () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/packages/${this.id}`)
        .then(resp => {
          this.packageData = resp.data
          this.fetchPackageHistory()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchPackageHistory () {
      if (!this.packageData) return
      this.isFetchingRecords = true
      let params = {
        form_types: 'registration',
        page: this.currentPage,
        page_size: this.pageSize
      }
      this.$axios.get(`/products/${this.packageData.product.id}/sales`, { params })
        .then(resp => {
          this.records = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingRecords = false
        })
    },
    pageChanged () {
      this.fetchPackageHistory()
    },
    goToPackages () {
      let route = { name: 'ClinicPackages' }
      if (this.$route?.params?.data && Object.keys(this.$route.params.data).length) {
        route = { ...route, ...this.$route.params.data }
      }
      return this.$router.push(route).catch(() => {})
    },
    goBack () {
      let route = { name: 'ClinicPackages' }
      if (this.$route?.params?.origin) {
        route = { name: this.$route.params.origin }
        if (this.$route.params.origin === 'EditClinicPackage') {
          route.params = { id: this.id }
        }
      }
      if (this.$route?.params?.data && Object.keys(this.$route.params.data).length) {
        route = { ...route, ...this.$route.params.data }
      }
      return this.$router.push(route).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-width {
  width: 50px !important;
}
</style>
